export enum NavigationItemType {
  LINK = 'link',
  MENU = 'menu',
}

export interface NavigationConfig {
  id: string;
  type: NavigationItemType;
  order: number;
}

export const NAVIGATION_ORDER: NavigationConfig[] = [
  { id: 'dashboard', type: NavigationItemType.LINK, order: 1 },
  { id: 'plans', type: NavigationItemType.LINK, order: 2 },
  { id: 'scripts', type: NavigationItemType.LINK, order: 3 },
  { id: 'fields', type: NavigationItemType.LINK, order: 4 },
  { id: 'fields-menu', type: NavigationItemType.MENU, order: 5 },
  { id: 'reports', type: NavigationItemType.LINK, order: 6 },
  { id: 'data-hub', type: NavigationItemType.LINK, order: 7 },
  { id: 'data', type: NavigationItemType.MENU, order: 8 },
  { id: 'programs', type: NavigationItemType.LINK, order: 9 },
  { id: 'experiments-labz', type: NavigationItemType.MENU, order: 10 },
];
